import { render, staticRenderFns } from "./Ticker.vue?vue&type=template&id=6d15500c&"
import script from "./Ticker.vue?vue&type=script&lang=js&"
export * from "./Ticker.vue?vue&type=script&lang=js&"
import style0 from "./Ticker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports